export const jeeMainsAdvanceReservationQuotas = [
  'OPEN_HS',
  'OPEN_GIRLS_HS',
  'EWS_HS',
  'EWS_GIRLS_HS',
  'OBC-NCL_HS',
  'OBC-NCL_GIRLS_HS',
  'SC_HS',
  'SC_GIRLS_HS',
  'OPEN_OS',
  'OPEN_GIRLS_OS',
  'EWS_OS',
  'OBC-NCL_OS',
  'OBC-NCL_GIRLS_OS',
  'SC_OS',
  'SC_GIRLS_OS',
  'ST_OS',
  'OBC-NCL (PwD)_GIRLS_OS',
  'OPEN (PwD)_HS',
  'OPEN (PwD)_OS',
  'EWS_GIRLS_OS',
  'ST_GIRLS_OS',
  'EWS (PwD)_OS',
  'ST_HS',
  'EWS (PwD)_HS',
  'SC (PwD)_HS',
  'ST_GIRLS_HS',
  'OPEN (PwD)_GIRLS_OS',
  'OBC-NCL (PwD)_OS',
  'ST (PwD)_OS',
  'SC (PwD)_OS',
  'OBC-NCL (PwD)_HS',
  'OPEN (PwD)_GIRLS_HS',
  'OBC-NCL (PwD)_GIRLS_HS',
  'ST (PwD)_HS',
  'EWS (PwD)_GIRLS_OS',
  'SC (PwD)_GIRLS_OS',
  'EWS (PwD)_GIRLS_HS',
  'ST (PwD)_GIRLS_OS',
  'OPEN_GO',
  'OPEN_GIRLS_GO',
  'OBC-NCL_GO',
  'OBC-NCL_GIRLS_GO',
  'SC_GO',
  'ST_GO',
  'EWS_GO',
  'SC_GIRLS_GO',
  'EWS_GIRLS_GO',
  'ST_GIRLS_GO',
  'OPEN_JK',
  'OPEN_GIRLS_JK',
  'SC_JK',
  'SC_GIRLS_JK',
  'ST_JK',
  'ST_GIRLS_JK',
  'EWS_JK',
  'OBC-NCL_JK',
  'OPEN_LA',
  'OPEN (PwD)_JK',
  'EWS_GIRLS_JK',
  'OBC-NCL_GIRLS_JK',
  'OPEN_GIRLS_LA',
  'OBC-NCL (PwD)_JK',
  'SC (PwD)_GIRLS_HS',
  'OPEN_AI',
  'OPEN_GIRLS_AI',
  'OPEN (PwD)_AI',
  'EWS_AI',
  'EWS_GIRLS_AI',
  'OBC-NCL_AI',
  'OBC-NCL_GIRLS_AI',
  'OBC-NCL (PwD)_AI',
  'SC_AI',
  'SC_GIRLS_AI',
  'SC (PwD)_AI',
  'ST_AI',
  'ST_GIRLS_AI',
  'ST (PwD)_AI',
  'OPEN (PwD)_GIRLS_AI',
  'EWS (PwD)_AI',
  'OBC-NCL (PwD)_GIRLS_AI',
  'EWS (PwD)_GIRLS_AI',
  'SC (PwD)_GIRLS_AI'
];

export const wbjeeMainsAdvanceReservationQuotas = [
  'TUITION_FEE_WAIVER_HS',
  'OPEN_AI',
  'OBC_B_HS',
  'OBC_A_HS',
  'OPEN_HS',
  'SC_HS',
  'ST_HS',
  'OPEN_PWD_HS',
  'SC_PWD_HS',
  'OBC_B_PWD_HS',
  'OBC_A_PWD_HS'
];

export const mhtcetReservationQuotas = [
  'LNT2S_I',
  'TFWS_I',
  'DEFOBCS_I',
  'LOPENS_I',
  'PWDOBCS_I',
  'EWS_I',
  'LNT1S_I',
  'DEFROBCS_I',
  'GSCS_I',
  'DEFRNT1S_I',
  'GNT2S_I',
  'GVJS_I',
  'GOPENS_I',
  'LSTS_I',
  'LNT3S_I',
  'LSCS_I',
  'DEFRSEBCS_I',
  'ORPHAN_I',
  'GOBCS_I',
  'PWDRSCS_I',
  'DEFOPENS_I',
  'GNT1S_I',
  'LSEBCS_I',
  'GSEBCS_I',
  'PWDOPENS_I',
  'GSTS_I',
  'GNT3S_I',
  'LVJS_I',
  'LOBCS_I',
  'PWDROBCS_I',
  'PWDOBCS_INP',
  'PWDOPENS_INP',
  'ORPHAN_VII',
  'DEFRSCS_I',
  'LSTS_II',
  'LSEBCS_II',
  'GNT2H_I',
  'LOBCH_I',
  'GOPENH_I',
  'GOBCH_I',
  'LOPENH_I',
  'GSEBCH_I',
  'GSTH_I',
  'GSCH_I',
  'PWDOPENH_INP',
  'GSTH_VII',
  'LSEBCH_VII',
  'LSEBCH_I',
  'GVJO_I',
  'LOPENO_I',
  'GSCO_I',
  'DEFOPENS_IND',
  'LSCH_I',
  'GVJH_I',
  'GSCH_VII',
  'LNT2H_II',
  'GOPENO_I',
  'GSEBCO_I',
  'GSTO_I',
  'GOBCO_I',
  'LSEBCO_VII',
  'GNT3H_I',
  'LOBCO_I',
  'PWDOPENH_I',
  'LSTH_I',
  'LNT1H_I',
  'LVJH_I',
  'PWDOBCH_INP',
  'GSEBCH_VII',
  'LSTH_II',
  'GNT2O_I',
  'LSTO_I',
  'GNT3O_I',
  'GSEBCO_VII',
  'LSTO_II',
  'DEFOBCS_IND',
  'GNT1H_I',
  'LNT3H_I',
  'PWDOBCH_I',
  'LNT2O_I',
  'LSCO_I',
  'LVJO_I',
  'LNT2H_I',
  'LSEBCH_II',
  'LSEBCO_I',
  'LSEBCO_II',
  'LNT1O_I',
  'LNT3O_I',
  'LSTO_VII',
  'GSTO_VII',
  'PWDSCH_INP',
  'DEFSCS_IND',
  'LVJH_II',
  'LSTH_VII',
  'PWDROBCH_I',
  'DEFSCS_I',
  'PWDRSTS_I',
  'DEFSEBCS_IND',
  'PWDSEBCS_VII',
  'DEFSEBCS_VII',
  'LSTS_VII',
  'LSEBCS_VII',
  'GSEBCS_VII',
  'GSTS_VII',
  'PWDSEBCS_INP',
  'PWDSCS_INP',
  'LNT3S_II',
  'LNT3S_VII',
  'LNT3H_II',
  'LNT3H_VII',
  'PWDSEBCH_VII',
  'GVJH_VII',
  'GNT3H_VII',
  'GNT1O_I',
  'LSCO_II',
  'LSCH_II',
  'LNT2O_II',
  'LNT1H_II',
  'GNT1H_VII',
  'GNT2O_VII',
  'GNT3O_VII',
  'MI_I',
  'LNT3O_VII',
  'LOBCH_II',
  'GNT2H_VII',
  'LVJH_VII',
  'GVJO_VII',
  'LNT3O_II',
  'LNT2H_VII',
  'LVJO_VII',
  'GNT3S_VII',
  'LSCH_VII',
  'LOPENH_II',
  'LNT2O_VII',
  'LNT1O_VII',
  'LNT1H_VII',
  'LVJO_II',
  'LVJS_II',
  'LOPENO_II',
  'PWDSEBCH_INP',
  'LOBCH_VII',
  'PWDOBCH_VII',
  'GOBCH_VII',
  'LOBCO_VII',
  'LOBCO_II',
  'GOBCO_VII',
  'LNT1S_II',
  'GNT2S_VII',
  'GOBCS_VII',
  'LNT2S_II',
  'PWDSEBCS_I',
  'DEFSEBCS_I',
  'GSCO_VII',
  'GNT1O_VII',
  'DEFOBCS_VII',
  'LSCO_VII',
  'GVJS_VII',
  'LVJS_VII',
  'LSCS_II',
  'LOBCS_II',
  'GSCS_VII',
  'LOPENS_II',
  'LOBCS_VII',
  'LSCS_VII',
  'LOPENO_VII',
  'PWDSCS_I',
  'LOPENH_VII',
  'LNT1O_II',
  'PWDSCH_VII',
  'DEFSCS_VII',
  'PWDRSCH_I',
  'LNT2S_VII',
  'LOPENS_VII',
  'LNT1S_VII',
  'GNT1S_VII',
  'PWDRSEBCH_I',
  'DEFRNT2S_I',
  'DEFRNT3S_I',
  'PWDRNT2H_I',
  'PWDSCH_I',
  'PWDSCS_VII',
  'PWDRNT3S_I',
  'PWDSTS_INP',
  'PWDRNT2S_I',
  'PWDOBCS_VII'
];
